import { Skeleton } from "components/ui/skeleton";

export default function SkeletonMusicLibrariesAlbum() {
  return (
    <div className={`flex w-[200px] h-full rounded-md border`}>
      <div className="">
        <div className="flex justify-center items-center w-full h-full rounded-tl-md rounded-bl-md">
          <Skeleton className="w-16 h-full rounded-tl-md rounded-bl-md" />
        </div>
      </div>

      <div className="py-1 px-2 w-full space-y-2 mt-1">
        <Skeleton className="w-full h-4" />
        <Skeleton className="w-full h-4" />
      </div>
    </div>
  );
}
